module.exports = __webpack_public_path__ + "devices.34f57576.svg";